/**
 * Reads the `recipientId` query param that names which signature a page is about.
 *
 * Shared rather than parsed per page: the task list, the request detail and the signing surface all
 * read the same param, and two of them hand it to the API as the row to act as. A page that parsed
 * it more loosely than its neighbour would sign a different signature than the one the signer
 * clicked, so the parse lives in one place.
 */
export function parseRecipientId(raw: string | null | undefined): number | null {
  if (raw == null || raw.trim() === '') return null;
  const parsed = Number(raw);
  return Number.isInteger(parsed) ? parsed : null;
}
